// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "zone.bitverse",
    name: "Bitverse",
    homepage: "https://www.bitverse.zone",
    image_id: "5851c585-0f2b-41a1-a36a-221a18af5200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/1645515614",
        android: "https://play.google.com/store/apps/details?id=com.bitverse.app&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/bitverse-wallet/gkeelndblnomfmjnophbhfhcjbcnemka",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bitverseapp://open/wallet",
        universal: "https://bitverseapp.page.link/?apn=com.bitverse.app&afl=https://bitverse.zone/download?deeplink%3Dbitverseapp://open/wallet&isi=1645515614&ibi=com.bitverse.app&link=https://bitverse.zone/download?deeplink%3Dbitverseapp://open/wallet?uri=",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map